// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
/* eslint-disable */
export const VERSION = {
    "dirty": false,
    "raw": "cb31db5",
    "hash": "cb31db5",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "cb31db5",
    "semverString": null,
    "version": "1.0.10"
};
/* tslint:enable */
